// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1bZA-","image":"Header_image__1zSHz","name":"Header_name__1Hcup","info":"Header_info__1tV5J","infoRow":"Header_infoRow__1yF4t"};